import BaseModal from '@/components/Modals/BaseModal';
import React from 'react';
const LastPayMethodModal = ({ handleCloseModal }) => {
  return (
    <BaseModal
      icon='/icons/warning-full.svg'
      title='Delete Payment Method'
      text='At least one payment method must remain on file. Please add a new payment method before deleting this one.'
      primaryButtonText='Ok'
      handlePrimaryButton={handleCloseModal}
    />
  );
};
export default LastPayMethodModal;
